import { render, staticRenderFns } from "./PermissionTab.vue?vue&type=template&id=48f759a1"
import script from "./PermissionTab.vue?vue&type=script&lang=js"
export * from "./PermissionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports